// extracted by mini-css-extract-plugin
module.exports = {"cssVerticalSlider":"HTMLRender_cssVerticalSlider__zLr_p","cssVerticalSliderInner":"HTMLRender_cssVerticalSliderInner__aFIzj"};